import store from '@/store';

const TwoFaModule = () => import(/* webpackChunkName: "2fa-module" */ './view/Module.vue');
const SetupAuth = () => import(/* webpackChunkName: "setup-auth" */ './view/SetupAuth.vue');
const GoogleSetup = () => import(/* webpackChunkName: "google-setup" */ './view/GoogleSetup.vue');
const GoogleVerifyOtp = () => import(/* webpackChunkName: "google-verify-otp" */ './view/GoogleVerifyOtp.vue');
const EditDashboard = () => import(/* webpackChunkName: "edit-2fa" */ './view/EditDashboard.vue');
const VerifyExistingOtp = () => import(/* webpackChunkName: "verify-existing-otp" */ './view/VerifyExistingOtp.vue');

const checkIsAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        return next({ name: "Home" });
    }
    next();
};

const redirectIf2faEnabled = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        return next({ name: "Home" });
    }

    if(from.name === 'TwoFaEdit' && (to.name == 'TwoFaGoogleSetup' || to.name == 'TwoFaGoogleVerifyOtp')){
        return next({ name : 'Home'});
    }

    const user = store.getters.stateUser;
    const isEditFlow = to.query.flow === 'edit';
    
    if (isEditFlow) {
        if (!user?.is_twofa_enable) {
            return next({ name: "Home" });
        }
        next();
    }

    if (user?.is_twofa_enable) {
        return next({ name: "Home" });
    }
    next();
};

const redirectIf2faDisabled = (to, from ,next) => {
    if (!store.getters.isAuthenticated) {
        return next({ name: "Home" });
    }
    
    const user = store.getters.stateUser;

    if (!user?.is_twofa_enable) {
        return next({ name: "Home" });
    }
    next()
};

const TwoFaRoutes = {
    path:      '/2fa',
    component: TwoFaModule,
    children: [
        {
            path:      'setup-auth',
            name:      'TwoFASetupAuth',
            component: SetupAuth,
            beforeEnter: checkIsAuthenticated
        },
        {
            path:      'google/setup',
            name:      'TwoFaGoogleSetup',
            component: GoogleSetup,
            beforeEnter: redirectIf2faEnabled
        },
        {
            path:      'google/verify',
            name:      'TwoFaGoogleVerifyOtp',
            component: GoogleVerifyOtp,
            beforeEnter: redirectIf2faEnabled
        },
        {
            path:      'edit-2fa',
            name:      'TwoFaEdit',
            component: EditDashboard,
            beforeEnter : redirectIf2faDisabled
        },
        {
            path:      'edit/verify/otp',
            name:      'TwoFaVerifyExistingOtp',
            component: VerifyExistingOtp,
            beforeEnter : redirectIf2faDisabled
        }
    ]
};

export default TwoFaRoutes;